// src/pages/ScambiPage.js
import React, { useEffect, useState } from 'react';
import './ScambiPage.css';
import TopBar from '../components/TopBar';
import { ArrowRightLeft, Globe2, Repeat, Sparkles } from 'lucide-react';
import ScambiWinToWinTab from '../components/scambi/ScambiWinToWinTab';
import ScambiLiberiTab from '../components/scambi/ScambiLiberiTab';
import ScambiCommunityTab from '../components/scambi/ScambiCommunityTab';
import { getOpenPublicTradesCount } from '../firebase/publicTradesService';

export default function ScambiPage() {
  const [tab, setTab] = useState('community');
  const [votableCount, setVotableCount] = useState(0);

  useEffect(() => {
    getOpenPublicTradesCount().then(setVotableCount).catch(() => setVotableCount(0));
  }, [tab]);

  const goToCommunity = () => setTab('community');

  return (
    <main className="container scambi-page">
      <TopBar />

      <section className="scambi-hero glass">
        <div className="scambi-hero__eyebrow">
          <Sparkles size={16} />
          Mercato tra fantallenatori
        </div>
        <h1>Scambi</h1>
        <p>
          Proponi uno scambio libero o cerca pacchetti vantaggiosi per entrambi nelle tue aste, rendili pubblici e
          lascia che sia la community a votarli.
        </p>
      </section>

      <div className="trade-mode-picker">
        <button
          type="button"
          className={`trade-mode-card glass${tab === 'liberi' ? ' trade-mode-card--active' : ''}`}
          onClick={() => setTab('liberi')}
        >
          <span className="trade-mode-card__icon"><ArrowRightLeft size={19} /></span>
          <span className="trade-mode-card__text">
            <strong>Scambi Liberi</strong>
            <span>Proponi uno scambio tra due giocatori qualsiasi e, se vuoi, fallo votare da tutti</span>
          </span>
          <span className="trade-mode-card__radio" aria-hidden="true" />
        </button>
        <button
          type="button"
          className={`trade-mode-card glass${tab === 'winwin' ? ' trade-mode-card--active' : ''}`}
          onClick={() => setTab('winwin')}
        >
          <span className="trade-mode-card__icon"><Repeat size={19} /></span>
          <span className="trade-mode-card__text">
            <strong>Scambi Win-To-Win</strong>
            <span>Scegli un'asta, i tuoi giocatori e una squadra: trova pacchetti vantaggiosi per entrambi</span>
          </span>
          <span className="trade-mode-card__radio" aria-hidden="true" />
        </button>
        <button
          type="button"
          className={`trade-mode-card glass${tab === 'community' ? ' trade-mode-card--active' : ''}`}
          onClick={() => setTab('community')}
        >
          <span className="trade-mode-card__icon"><Globe2 size={19} /></span>
          <span className="trade-mode-card__text">
            <strong>Community</strong>
            <span>Vota gli scambi pubblici di tutti e gestisci i tuoi</span>
          </span>
          {votableCount > 0 && <span className="trade-mode-card__badge">{votableCount}</span>}
          <span className="trade-mode-card__radio" aria-hidden="true" />
        </button>
      </div>

      {tab === 'liberi' && <ScambiLiberiTab onGoToCommunity={goToCommunity} />}
      {tab === 'winwin' && <ScambiWinToWinTab onGoToCommunity={goToCommunity} />}
      {tab === 'community' && <ScambiCommunityTab />}
    </main>
  );
}
